const axios = require('axios')

const SERVICE = 'file-service'

const getFileAdminApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .processFile(`/admin/file/${id}`, id)

// const uploadFilesApi = async (api, body, resUrl) => api.setService(SERVICE).client.request({
//   method: 'PUT',
//   data: body,
//   baseUrl: resUrl,
//   // url: `${api.service}/file`,
//   headers: {
//     ...api.optionsObject.headers,
//     'Content-Type': 'multipart/form-data',
//   },
// })

const getFilesUploadURLAdminApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/file')

const getFileApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .processFile(`/file/${id}`, id)

const getMultipleFileApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/file/id')

// const uploadFilesApi = async (api, body, resUrl) => api.setService(SERVICE).client.request({
//   method: 'PUT',
//   data: body,
//   baseUrl: resUrl,
//   // url: `${api.service}/file`,
//   headers: {
//     ...api.optionsObject.headers,
//     'Content-Type': 'multipart/form-data',
//   },
// })

const getFilesUploadURLApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/file')

// eslint-disable-next-line no-unused-vars
const uploadFilesApi = async (body, resUrl, dataType) => {
  const fileInstance = axios.create({
    timeout: 30000,
  })
  const headersList = {
    Accept: '*/*',
    // 'Content-Type': dataType === 'pdf' ? 'application/pdf' : `image/${dataType}`,
    'Content-Type': 'application/octet-stream',
  }

  const reqOptions = {
    url: resUrl,
    method: 'PUT',
    headers: headersList,
    data: body,
  }
  const response = await fileInstance.request(reqOptions)
  return response
}

module.exports = {
  getFileAdminApi,
  getFilesUploadURLAdminApi,
  getFileApi,
  getMultipleFileApi,
  getFilesUploadURLApi,
  uploadFilesApi,
}
